// Author Shi Wen Long
// Date 2024-08-01 14:18:58

class SithMesStoolPr {
    constructor({
                    id = null,
                    projectId = '',
                    purchaseGroup = '',
                    prNumber = '',
                    prItemNumber = '',
                    plant = '',
                    fixedVendor = '',
                    momFixedVendor = '',
                    momFixedVendorName = '',
                    material = '',
                    shortText = '',
                    descriptionZh = '',
                    poText = '',
                    materialGroup = '',
                    itemDlvDate = '',
                    prdScheduleDate = '',
                    dlvSubtractSchedule = '',
                    itemCategory = '',
                    deliverLocation = '',
                    wbsElement = '',
                    qtyRequested = '',
                    qtyOrdered = '',
                    creationDate = '',
                    mrpController = '',
                    prUnit = '',
                    personCreat = '',
                    requester = '',
                    qtyOpen = '',
                    exceptionMessageNumber = '',
                    availableQuantity = '',
                    engineer = '',
                    profitCenter = '',
                    category = '',
                    networkNumber = '',
                    salesDocumentNumber = '',
                    salesItem = '',
                    prReleaseDate = '',
                    supportTime = '',
                    orderNumber = '',
                    sapStatus = '',
                    priority = '',
                    isExist26Stock = '',
                    supportStatus = '',
                    isLocked = '',
                    prReport = '',
                    prAsnReport = '',
                    remark = '',
                    prReportList = '',
                    prAsnReportList = ''
                }
                        = {}) {
        this.id = id;
        this.projectId = projectId;
        this.purchaseGroup = purchaseGroup;
        this.prNumber = prNumber;
        this.prItemNumber = prItemNumber;
        this.plant = plant;
        this.fixedVendor = fixedVendor;
        this.momFixedVendor = momFixedVendor;
        this.momFixedVendorName = momFixedVendorName;
        this.material = material;
        this.shortText = shortText;
        this.descriptionZh = descriptionZh;
        this.poText = poText;
        this.materialGroup = materialGroup;
        this.itemDlvDate = itemDlvDate;
        this.prdScheduleDate = prdScheduleDate;
        this.dlvSubtractSchedule = dlvSubtractSchedule;
        this.itemCategory = itemCategory;
        this.deliverLocation = deliverLocation;
        this.wbsElement = wbsElement;
        this.qtyRequested = qtyRequested;
        this.qtyOrdered = qtyOrdered;
        this.creationDate = creationDate;
        this.mrpController = mrpController;
        this.prUnit = prUnit;
        this.personCreat = personCreat;
        this.requester = requester;
        this.qtyOpen = qtyOpen;
        this.exceptionMessageNumber = exceptionMessageNumber;
        this.availableQuantity = availableQuantity;
        this.engineer = engineer;
        this.profitCenter = profitCenter;
        this.category = category;
        this.networkNumber = networkNumber;
        this.salesDocumentNumber = salesDocumentNumber;
        this.salesItem = salesItem;
        this.prReleaseDate = prReleaseDate;
        this.supportTime = supportTime;
        this.orderNumber = orderNumber;
        this.sapStatus = sapStatus;
        this.priority = priority;
        this.isExist26Stock = isExist26Stock;
        this.supportStatus = supportStatus;
        this.isLocked = isLocked;
        this.prReport = prReport;
        this.prAsnReport = prAsnReport;
        this.remark = remark;
        this.prReportList = prReportList;
        this.prAsnReportList = prAsnReportList;
    }
}

function newEntity() {
    return new SithMesStoolPr();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolPr.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectId',
            label: 'label.sith.stool.sithMesStoolPr.grid.projectId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.stool.sithMesStoolPr.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolPr.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsNumber',
            label: 'label.sith.stool.sithMesStoolPr.grid.wbsNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseGroup',
            label: 'label.sith.stool.sithMesStoolPr.grid.purchaseGroup',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prNumber',
            label: 'label.sith.stool.sithMesStoolPr.grid.prNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prItemNumber',
            label: 'label.sith.stool.sithMesStoolPr.grid.prItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.stool.sithMesStoolPr.grid.plant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'fixedVendor',
            label: 'label.sith.stool.sithMesStoolPr.grid.fixedVendor',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'fixedVendorName',
            label: 'label.sith.stool.sithMesStoolPr.grid.fixedVendorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'momFixedVendor',
            label: 'label.sith.stool.sithMesStoolPr.grid.momFixedVendor',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'momFixedVendorName',
            label: 'label.sith.stool.sithMesStoolPr.grid.momFixedVendorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'material',
            label: 'label.sith.stool.sithMesStoolPr.grid.material',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'material_bom',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bulk',
            label: 'label.sith.stool.sithMesStoolPr.grid.bulk',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'shortText',
            label: 'label.sith.stool.sithMesStoolPr.grid.shortText',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'descriptionZh',
            label: 'label.sith.stool.sithMesStoolPr.grid.descriptionZh',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poText',
            label: 'label.sith.stool.sithMesStoolPr.grid.poText',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialGroup',
            label: 'label.sith.stool.sithMesStoolPr.grid.materialGroup',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'machine1',
            label: 'label.sith.stool.sithMesStoolPr.grid.machine1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pm',
            label: 'label.sith.stool.sithMesStoolPr.grid.pm',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cpm',
            label: 'label.sith.stool.sithMesStoolPr.grid.cpm',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'om',
            label: 'label.sith.stool.sithMesStoolPr.grid.om',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pmName',
            label: 'label.sith.stool.sithMesStoolPr.grid.pmName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cpmName',
            label: 'label.sith.stool.sithMesStoolPr.grid.cpmName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'omName',
            label: 'label.sith.stool.sithMesStoolPr.grid.omName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engCoreCompressor',
            label: 'label.sith.stool.sithMesStoolPr.grid.engCoreCompressor',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engSteamTurbine',
            label: 'label.sith.stool.sithMesStoolPr.grid.engSteamTurbine',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engSystem',
            label: 'label.sith.stool.sithMesStoolPr.grid.engSystem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engIc',
            label: 'label.sith.stool.sithMesStoolPr.grid.engIc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemDlvDate',
            label: 'label.sith.stool.sithMesStoolPr.grid.itemDlvDate',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdScheduleDate',
            label: 'label.sith.stool.sithMesStoolPr.grid.prdScheduleDate',
            sortable: true,
            form: {
                type: 'datepicker',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dlvSubtractSchedule',
            label: 'label.sith.stool.sithMesStoolPr.grid.dlvSubtractSchedule',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemCategory',
            label: 'label.sith.stool.sithMesStoolPr.grid.itemCategory',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliverLocation',
            label: 'label.sith.stool.sithMesStoolPr.grid.deliverLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsElement',
            label: 'label.sith.stool.sithMesStoolPr.grid.wbsElement',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'qtyRequested',
            label: 'label.sith.stool.sithMesStoolPr.grid.qtyRequested',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'qtyOrdered',
            label: 'label.sith.stool.sithMesStoolPr.grid.qtyOrdered',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'creationDate',
            label: 'label.sith.stool.sithMesStoolPr.grid.creationDate',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mrpController',
            label: 'label.sith.stool.sithMesStoolPr.grid.mrpController',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prUnit',
            label: 'label.sith.stool.sithMesStoolPr.grid.prUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'personCreat',
            label: 'label.sith.stool.sithMesStoolPr.grid.personCreat',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'requester',
            label: 'label.sith.stool.sithMesStoolPr.grid.requester',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'qtyOpen',
            label: 'label.sith.stool.sithMesStoolPr.grid.qtyOpen',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'exceptionMessageNumber',
            label: 'label.sith.stool.sithMesStoolPr.grid.exceptionMessageNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'availableQuantity',
            label: 'label.sith.stool.sithMesStoolPr.grid.availableQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engineer',
            label: 'label.sith.stool.sithMesStoolPr.grid.engineer',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'profitCenter',
            label: 'label.sith.stool.sithMesStoolPr.grid.profitCenter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'category',
            label: 'label.sith.stool.sithMesStoolPr.grid.category',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'networkNumber',
            label: 'label.sith.stool.sithMesStoolPr.grid.networkNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesDocumentNumber',
            label: 'label.sith.stool.sithMesStoolPr.grid.salesDocumentNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesItem',
            label: 'label.sith.stool.sithMesStoolPr.grid.salesItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prReleaseDate',
            label: 'label.sith.stool.sithMesStoolPr.grid.prReleaseDate',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'supportTime',
            label: 'label.sith.stool.sithMesStoolPr.grid.supportTime',
            sortable: true,
            form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderNumber',
            label: 'label.sith.stool.sithMesStoolPr.grid.orderNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapStatus',
            label: 'label.sith.stool.sithMesStoolPr.grid.sapStatus',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'priority',
            label: 'label.sith.stool.sithMesStoolPr.grid.priority',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isExist26Stock',
            label: 'label.sith.stool.sithMesStoolPr.grid.isExist26Stock',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'supportStatus',
            label: 'label.sith.stool.sithMesStoolPr.grid.supportStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '未维护'},
                    {value: '1', text: '已维护'}
                ]
            }
        },
        {
            key: 'isLocked',
            label: 'label.sith.stool.sithMesStoolPr.grid.isLocked',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isAsn',
            label: 'label.sith.stool.sithMesStoolPr.grid.isAsn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prReportList',
            label: 'label.sith.stool.sithMesStoolPr.grid.prReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prAsnReportList',
            label: 'label.sith.stool.sithMesStoolPr.grid.prAsnReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'filterByNeedReadRequireDateChangeHistory',
            label: 'label.sith.stool.sithMesStoolPr.grid.filterByNeedReadRequireDateChangeHistory',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transporter',
            label: 'label.sith.stool.sithMesStoolPr.grid.transporter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolPr.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'existManualCheck',
            label: 'label.sith.stool.sithMesStoolPr.grid.existManualCheck',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    prListFilter: [],
    purchaseGroupFilter: '',
    prNumberFilter: '',
    projectNameFilter: '',
    projectCodeFilter: '',
    wbsNumberFilter: '',
    omFilter: '',
    pmFilter: '',
    cpmFilter: '',
    omNameFilter: '',
    pmNameFilter: '',
    cpmNameFilter: '',
    prItemNumberFilter: '',
    plantFilter: '',
    fixedVendorFilter: '',
    fixedVendorNameFilter: '',
    momFixedVendorFilter: '',
    momFixedVendorNameFilter: '',
    materialFilter: '',
    bulkFilter: '',
    shortTextFilter: '',
    descriptionZhFilter: '',
    poTextFilter: '',
    materialGroupFilter: '',
    itemDlvDateRteFilter: '',
    itemDlvDateLteFilter: '',
    prdScheduleDateRteFilter: '',
    prdScheduleDateLteFilter: '',
    dlvSubtractScheduleFilter: '',
    deliveryDateIsOnTimeFilter: '',
    gteZeroFilter: '',
    ltZeroFilter: '',
    itemCategoryFilter: '',
    deliverLocationFilter: '',
    wbsElementFilter: '',
    qtyRequestedFilter: '',
    qtyOrderedFilter: '',
    creationDateRteFilter: '',
    creationDateLteFilter: '',
    mrpControllerFilter: '',
    prUnitFilter: '',
    personCreatFilter: '',
    requesterFilter: '',
    qtyOpenFilter: '',
    exceptionMessageNumberFilter: '',
    availableQuantityFilter: '',
    engineerFilter: '',
    profitCenterFilter: '',
    categoryFilter: '',
    networkNumberFilter: '',
    salesDocumentNumberFilter: '',
    salesItemFilter: '',
    prReleaseDateRteFilter: '',
    prReleaseDateLteFilter: '',
    supportTimeRteFilter: '',
    supportTimeLteFilter: '',
    orderNumberFilter: '',
    sapStatusFilter: '',
    priorityFilter: '',
    isExist26StockFilter: '',
    supportStatusFilter: '',
    isLockedFilter: '',
    isAsnFilter: '',
    isOpenFilter: '',
    filterByNeedReadRequireDateChangeHistoryFilter: '',
    existManualCheckFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'purchaseGroupFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.purchaseGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prNumberFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.prNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumberFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.wbsNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.om',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.pm',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.cpm',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omNameFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.omName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmNameFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.pmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmNameFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.cpmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.prItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'fixedVendorFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.fixedVendor',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'fixedVendorNameFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.fixedVendorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'momFixedVendorFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.momFixedVendor',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'momFixedVendorNameFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.momFixedVendorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulkFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.bulk',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shortTextFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.shortText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionZhFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.descriptionZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poTextFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.poText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialGroupFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.materialGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDlvDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.itemDlvDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDlvDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.itemDlvDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.prdScheduleDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.prdScheduleDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractScheduleFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.dlvSubtractSchedule',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateIsOnTimeFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.deliveryDateIsOnTime',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.itemCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocationFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.deliverLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElementFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.wbsElement',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qtyRequestedFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.qtyRequested',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qtyOrderedFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.qtyOrdered',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creationDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.creationDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creationDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.creationDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mrpControllerFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.mrpController',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prUnitFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.prUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'personCreatFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.personCreat',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requesterFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.requester',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qtyOpenFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.qtyOpen',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumberFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.exceptionMessageNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'availableQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.availableQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineerFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.engineer',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenterFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.profitCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'categoryFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.category',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'networkNumberFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.networkNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentNumberFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.salesDocumentNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesItemFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.salesItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prReleaseDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.prReleaseDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prReleaseDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.prReleaseDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.supportTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.supportTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumberFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.orderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapStatusFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.sapStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'priorityFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.priority',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isExist26StockFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.isExist26Stock',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatusFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.supportStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'isLockedFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.isLocked',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsnFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.isAsn',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'filterByNeedReadRequireDateChangeHistoryFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.filterByNeedReadRequireDateChangeHistory',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transporterFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.transporter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'existManualCheckFilter',
        label: 'label.sith.stool.sithMesStoolPr.filter.existManualCheck',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'purchaseGroup',
        label: 'label.sith.stool.sithMesStoolPr.entity.purchaseGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prNumber',
        label: 'label.sith.stool.sithMesStoolPr.entity.prNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemNumber',
        label: 'label.sith.stool.sithMesStoolPr.entity.prItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.stool.sithMesStoolPr.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'fixedVendor',
        label: 'label.sith.stool.sithMesStoolPr.entity.fixedVendor',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'momFixedVendor',
        label: 'label.sith.stool.sithMesStoolPr.entity.momFixedVendor',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'momFixedVendorName',
        label: 'label.sith.stool.sithMesStoolPr.entity.momFixedVendorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.stool.sithMesStoolPr.entity.material',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shortText',
        label: 'label.sith.stool.sithMesStoolPr.entity.shortText',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionZh',
        label: 'label.sith.stool.sithMesStoolPr.entity.descriptionZh',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poText',
        label: 'label.sith.stool.sithMesStoolPr.entity.poText',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialGroup',
        label: 'label.sith.stool.sithMesStoolPr.entity.materialGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDlvDate',
        label: 'label.sith.stool.sithMesStoolPr.entity.itemDlvDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDate',
        label: 'label.sith.stool.sithMesStoolPr.entity.prdScheduleDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractSchedule',
        label: 'label.sith.stool.sithMesStoolPr.entity.dlvSubtractSchedule',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCategory',
        label: 'label.sith.stool.sithMesStoolPr.entity.itemCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocation',
        label: 'label.sith.stool.sithMesStoolPr.entity.deliverLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElement',
        label: 'label.sith.stool.sithMesStoolPr.entity.wbsElement',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qtyRequested',
        label: 'label.sith.stool.sithMesStoolPr.entity.qtyRequested',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qtyOrdered',
        label: 'label.sith.stool.sithMesStoolPr.entity.qtyOrdered',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creationDate',
        label: 'label.sith.stool.sithMesStoolPr.entity.creationDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mrpController',
        label: 'label.sith.stool.sithMesStoolPr.entity.mrpController',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prUnit',
        label: 'label.sith.stool.sithMesStoolPr.entity.prUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'personCreat',
        label: 'label.sith.stool.sithMesStoolPr.entity.personCreat',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requester',
        label: 'label.sith.stool.sithMesStoolPr.entity.requester',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qtyOpen',
        label: 'label.sith.stool.sithMesStoolPr.entity.qtyOpen',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumber',
        label: 'label.sith.stool.sithMesStoolPr.entity.exceptionMessageNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'availableQuantity',
        label: 'label.sith.stool.sithMesStoolPr.entity.availableQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineer',
        label: 'label.sith.stool.sithMesStoolPr.entity.engineer',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenter',
        label: 'label.sith.stool.sithMesStoolPr.entity.profitCenter',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'category',
        label: 'label.sith.stool.sithMesStoolPr.entity.category',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'networkNumber',
        label: 'label.sith.stool.sithMesStoolPr.entity.networkNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentNumber',
        label: 'label.sith.stool.sithMesStoolPr.entity.salesDocumentNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesItem',
        label: 'label.sith.stool.sithMesStoolPr.entity.salesItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prReleaseDate',
        label: 'label.sith.stool.sithMesStoolPr.entity.prReleaseDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTime',
        label: 'label.sith.stool.sithMesStoolPr.entity.supportTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumber',
        label: 'label.sith.stool.sithMesStoolPr.entity.orderNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapStatus',
        label: 'label.sith.stool.sithMesStoolPr.entity.sapStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'priority',
        label: 'label.sith.stool.sithMesStoolPr.entity.priority',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isExist26Stock',
        label: 'label.sith.stool.sithMesStoolPr.entity.isExist26Stock',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatus',
        label: 'label.sith.stool.sithMesStoolPr.entity.supportStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'isLocked',
        label: 'label.sith.stool.sithMesStoolPr.entity.isLocked',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prReportList',
        label: 'label.sith.stool.sithMesStoolPr.entity.prReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'prReport'
        }
    },
    {
        key: 'prAsnReportList',
        label: 'label.sith.stool.sithMesStoolPr.entity.prAsnReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'prAsnReport'
        }
    }
]

export {
    SithMesStoolPr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
